import React from 'react';
import { MapPin, Mail, Phone, Facebook, Instagram, Linkedin, Twitter } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const navLinks = [
    { label: 'Home', href: '#inicio' },
    { label: 'A Armadilha', href: '#redundancia' },
    { label: 'A Solução', href: '#solucao' },
    { label: 'Serviços', href: '#servicos' }
  ];

  const socialLinks = [
    { icon: Facebook, href: '#', label: 'Facebook' },
    { icon: Instagram, href: '#', label: 'Instagram' },
    { icon: Linkedin, href: '#', label: 'LinkedIn' },
    { icon: Twitter, href: '#', label: 'Twitter' }
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-gray-300">
      {/* Main Footer */}
      <div className="container mx-auto px-4 py-12 md:py-16">
        <div className="grid md:grid-cols-3 gap-8 md:gap-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <img
                src="https://www.tmctelecomunicacoes.com.br/site/wp-content/uploads/2026/06/logo-branco-100px.png"
                alt="TMC Telecomunicações"
                className="h-10 w-auto"
              />
            </div>
            <p className="text-gray-400 leading-relaxed mb-6">
              Soluções de conectividade corporativa com redundância garantida. Mais de 15 anos de experiência em telecomunicações.
            </p>
            {/* Social Links */}
            <div className="flex space-x-4">
              {socialLinks.map((social, index) => {
                const Icon = social.icon;
                return (
                  <a
                    key={index}
                    href={social.href}
                    aria-label={social.label}
                    className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-[#0079be] transition-colors duration-300"
                  >
                    <Icon className="w-5 h-5" />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-bold text-lg text-white mb-6">Navegação</h4>
            <ul className="space-y-3">
              {navLinks.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    onClick={(e) => scrollToSection(e, link.href)}
                    className="hover:text-[#0079be] transition-colors duration-300 inline-block"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold text-lg text-white mb-6">Contato</h4>
            <ul className="space-y-4">
              <li>
                <a
                  href="mailto:contato@tmctelecomunicacoes.com.br"
                  className="flex items-start space-x-3 hover:text-[#0079be] transition-colors duration-300"
                >
                  <Mail className="w-5 h-5 flex-shrink-0 mt-0.5" />
                  <span>contato@tmctelecomunicacoes.com.br</span>
                </a>
              </li>
              <li>
                <a
                  href="tel:+551135352954"
                  className="flex items-start space-x-3 hover:text-[#0079be] transition-colors duration-300"
                >
                  <Phone className="w-5 h-5 flex-shrink-0 mt-0.5" />
                  <span>(11) 3535-2954</span>
                </a>
              </li>
              <li>
                <div className="flex items-start space-x-3">
                  <MapPin className="w-5 h-5 flex-shrink-0 mt-0.5" />
                  <div>
                    <p>Av. das Nações Unidas, nº 13.797</p>
                    <p>Bloco II, 11º andar, Sala B</p>
                    <p>Morumbi - São Paulo/SP</p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              © {currentYear} TMC Telecomunicações. Todos os direitos reservados.
            </p>
            <div className="flex space-x-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-[#0079be] transition-colors duration-300">
                Política de Privacidade
              </a>
              <a href="#" className="text-gray-400 hover:text-[#0079be] transition-colors duration-300">
                Termos de Uso
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;